<template>
  <div class="form__container">
    <building-construction-mode :building="building" />
    <div v-if="building.constructionMode !== null">
      <h3 data-test-id="work-steps-heading" class="form__subtitle" v-html="$t('workSteps')" />

      <div class="row">
        <div class="col form__col">
          <p data-test-id="planned-dates-heading">
            <strong>{{ $t('plannedDates') }} </strong>
          </p>
          <p data-test-id="planned-dates-description1">{{ plannedDatesDesc1 }}</p>
          <p data-test-id="planned-dates-description2">{{ $t('plannedDatesDesc2') }}</p>
        </div>
      </div>
      <building-planned-dates :planned-dates="building.plannedDates" :is-modular="building.constructionMode === 'MODULAR'" />
      <contacts :contacts="building.contacts" />
    </div>
  </div>
</template>

<script>
import BuildingConstructionMode from '@/components/building/edit/construction-site/BuildingConstructionMode'
import BuildingPlannedDates from '@/components/building/edit/construction-site/BuildingPlannedDates'
import Contacts from '@/components/building/edit/construction-site/Contacts'

export default {
  components: { BuildingConstructionMode, BuildingPlannedDates, Contacts },
  props: {
    building: Object
  },
  computed: {
    plannedDatesDesc1() {
    return this.building?.constructionMode === 'MODULAR'
    ? this.$t('plannedDatesDesc1Modular')
    : this.$t('plannedDatesDesc1')
   }
  }
}
</script>
